import React from 'react';

import CostComponentProto from "./cost-proto";

export default function renderStringInList(type, props) {
    return <CostComponentProto renderMode="list" type={type} {...props} />;
}